import { z } from 'zod';
import { CognitoSubSchema, EmailSchema, TimestampSchema, UserStatusSchema } from '../common.js';
/**
 * CloneAI team member — see docs/data-model.md §4.4.
 * Lives under `PK = SYSTEM`, `SK = SUPERADMIN#<sub>`.
 * Cognito `custom:tenantId = "__system__"`.
 */
export const SuperAdminSchema = z.object({
    userId: CognitoSubSchema,
    email: EmailSchema,
    firstName: z.string().min(1).max(60),
    lastName: z.string().min(1).max(60),
    status: UserStatusSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
    /** Sub of the super-admin who created this one; null for the bootstrapped first one. */
    createdBy: CognitoSubSchema.nullable(),
    lastLoginAt: TimestampSchema.nullable(),
});
/**
 * Subset returned by `POST /v1/admin/super-admins/invite`.
 *
 * Super-admin invites don't produce a DDB `Invite` row — Cognito's
 * customMessage trigger owns the email, and the `SuperAdmin` row is created
 * directly in `invited` status. This shape mirrors the tenant-side
 * `InviteSummary` for frontend consistency, but `role` is fixed to
 * `'super-admin'` and `userId` (the Cognito sub) takes the place of `inviteId`.
 */
export const SuperAdminInviteSummarySchema = z.object({
    userId: CognitoSubSchema,
    email: EmailSchema,
    role: z.literal('super-admin'),
    status: UserStatusSchema,
    invitedByEmail: EmailSchema,
    createdAt: TimestampSchema,
});
//# sourceMappingURL=superAdmin.js.map